export type NotificationSoundType =
    | "new-order"
    | "bill-requested"
    | "order-ready"
    | "order-cancelled";

const sounds: Record<NotificationSoundType, HTMLAudioElement> = {
    "new-order": new Audio("/sounds/new-order.mp3"),
    "bill-requested": new Audio("/sounds/bill-requested.mp3"),
    "order-ready": new Audio("/sounds/new-order.mp3"),
    "order-cancelled": new Audio("/sounds/new-order.mp3"),
};

Object.values(sounds).forEach(audio => {
    audio.preload = "auto";
});

export const playNotificationSound = async (
    type: NotificationSoundType
) => {
    try {
        const audio = sounds[type];

        // Ako dva eventa dođu brzo jedan za drugim,
        // kreni ponovo od početka.
        audio.currentTime = 0;

        await audio.play();
    } catch (error) {
        console.warn(
            "Browser je blokirao reprodukciju zvuka.",
            error
        );
    }
};

export const unlockNotificationSound = async () => {
    try {
        const audio = sounds["new-order"];
        audio.volume = 0.01;
        await audio.play();
        audio.pause();
        audio.currentTime = 0;
        audio.volume = 1;
    } catch (error) {
        console.warn("Browser je blokirao reprodukciju zvuka.", error);
    }
};

export const requestBrowserNotificationPermission = async () => {
    if (!("Notification" in window)) {
        return false;
    }

    if (Notification.permission === "granted") {
        return true;
    }

    if (Notification.permission === "denied") {
        return false;
    }

    const permission = await Notification.requestPermission();

    return permission === "granted";
};

interface ShowBrowserNotificationProps {
    title: string;
    body: string;
    url?: string;
    tag?: string;
}

export const showBrowserNotification = async ({
    title,
    body,
    url = "/",
    tag,
}: ShowBrowserNotificationProps) => {
    if (!("serviceWorker" in navigator)) {
        return;
    }

    if (!("Notification" in window)) {
        return;
    }

    if (Notification.permission !== "granted") {
        return;
    }

    try {
        const registration = await navigator.serviceWorker.ready;

        await registration.showNotification(title, {
            body,

            icon: "/icons/notification-icon.png",
            badge: "/icons/notification-badge.png",

            tag,

            // Nemoj silent:true jer želimo OS notification sound
            silent: false,

            data: {
                url,
            },
        });
    } catch (error) {
        console.error(
            "Greška pri prikazivanju browser notifikacije:",
            error
        );
    }
};